import { ConnectComponent } from '../../_components/ConnectComponent'
import { LocationScopeView } from './LocationScope.view'
import { LocationScopePresenter } from './LocationScope.presenter'

export const LocationScope = ConnectComponent(
  LocationScopeView,
  LocationScopePresenter,
)
